export const urlFriendlyString = (value) => {
  return typeof value === "undefined" ? "" : value.replace(/[^a-z0-9_]+/gi, "-").replace(/^-|-$/g, "").toLowerCase();
};
